export default __webpack_public_path__ + "static/media/panorame.693d281b.svg";